<template>
  <Toast />
  <TabView>
    <TabPanel v-if="false" :disabled="!data_cliente_id">
      <template #header>
        <div class="custom-tab">
          <i class="pi pi-file mr-1"></i>
          <span class="estilo-titulo-tab">Historia Clínica</span>
        </div>
      </template>
      <FormHistoriaClinica
        :datos_historia_clinica="datos_historia_clinica"
        :cliente_id="data_cliente_id"
        @actualizarListado="obtenerHistoriaClinica"
      />
    </TabPanel>

    <TabPanel :disabled="!data_cliente_id">
      <template #header>
        <div class="custom-tab">
          <i class="pi pi-file mr-1"></i>
          <span class="estilo-titulo-tab">H.C. Niño</span>
        </div>
      </template>
      <HistoriaClinicaKid
        :datos_historia="datos_historia_kid"
        :cliente_id="data_cliente_id"
        @actualizarListado="obtenerHistoriaClinicaKid"
      />
    </TabPanel>

    <TabPanel :disabled="!data_cliente_id">
      <template #header>
        <div class="custom-tab">
          <i class="pi pi-file mr-1"></i>
          <span class="estilo-titulo-tab">H.C. Adulto</span>
        </div>
      </template>
      <HistoriaClinicaAdulto :cliente_id="data_cliente_id" @actualizarListado="obtenerHistoriaClinica" />
    </TabPanel>

    <TabPanel :disabled="!data_cliente_id">
      <template #header>
        <div class="custom-tab" @click="obtenerCuestionarioPersonal()">
          <i class="pi pi-list mr-1"></i>
          <span class="estilo-titulo-tab">Cuestionario Personal</span>
        </div>
      </template>
      <CuestionarioPersonal
        :cuestionario_personal="cuestionario_personal"
        :cliente_id="data_cliente_id"
        @actualizarListado="obtenerCuestionarioPersonal"
      />
    </TabPanel>
  </TabView>
</template>

<script>
import PlanTratamientoService from '@/service/PlanTratamientoService'
import FormHistoriaClinica from '@/module/plantratamientos/FormHistoriaClinica.vue'
import HistoriaClinicaKid from '@/module/plantratamientos/HistoriaClinicaKid.vue'
import HistoriaClinicaAdulto from '@/module/plantratamientos/HistoriaClinicaAdulto.vue'
import CuestionarioPersonal from '@/module/plantratamientos/CuestionarioPersonal.vue'
import { useAuth } from '@/stores'

export default {
  components: {
    FormHistoriaClinica,
    HistoriaClinicaKid,
    HistoriaClinicaAdulto,
    CuestionarioPersonal
  },
  emits: ['actualizarListado'],
  props: {
    cliente_id: { type: Number, default: 0 },
    datos_historia_clinica: { type: Object, default: () => ({}) }
  },
  planTratamientoService: null,
  auth: null,
  created() {
    this.planTratamientoService = new PlanTratamientoService()
    this.auth = useAuth()
  },
  data() {
    return {
      data_cliente_id: this.cliente_id,
      cuestionario_personal: {},
      datos_historia_kid: {},
      guardando: false,
      cargando: false
    }
  },
  methods: {
    obtenerHistoriaClinicaKid() {
      if (!this.data_cliente_id) return
      this.planTratamientoService.getHistoriaClinicaKid({ cliente_id: this.data_cliente_id }).then((response) => {
        this.datos_historia_kid = response.data || {}
      })
    },
    obtenerHistoriaClinica() {
      this.$emit('actualizarListado')
    },
    obtenerCuestionarioPersonal() {
      this.cargando = true
      this.planTratamientoService.obtenerCuestionarioPersonal({ cliente_id: this.data_cliente_id }).then((response) => {
        if (response.success == false) {
          this.$toast.add({ severity: 'error', summary: 'Cuestionario Personal', detail: response.message, life: 3000 })
          this.cuestionario_personal = {}
        } else {
          this.cuestionario_personal = response.cuestionario_personal || {}
          this.$toast.add({
            severity: 'success',
            summary: 'Cuestionario Personal',
            detail: response.message,
            life: 3000
          })
        }
        this.cargando = false
      })
    }
  },
  watch: {
    cliente_id(val) {
      this.data_cliente_id = val
      this.obtenerHistoriaClinicaKid()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
canvas {
  border: 0.5px solid #002236;
}
.estilo-titulo-tab {
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  color: #002236;
}
.custom-tab {
  display: flex;
  align-items: center;
  padding: 0px;
  cursor: pointer;
}
.custom-tab:hover {
  background-color: #f0f0f0;
}
.p-tabview-nav {
  background-color: #e0e0e0;
}
.p-tabview-nav .p-tabview-selected {
  background-color: #002236;
  color: #fff;
}
.p-tabview-nav .p-tabview-selected .custom-tab {
  background-color: #002236;
  color: #fff;
}
</style>